export default __webpack_public_path__ + "static/media/Instagram.7dfc09ef.svg";